<template>
    <div id="graficoContainer">
        <span class="TituloGrafico" v-if="hasTitulo">{{titulo}}</span>
        <div id="grafPiramide" ref="graficoPiramide"></div>
    </div>
</template>

<script>

import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'
import am4themes_animated from '@amcharts/amcharts4/themes/animated'
import MetodosGlobais from '@/utils/MetodosGlobais'
import CorUtil from '@/utils/CorUtils'

am4core.useTheme(am4themes_animated)
export default {
  name: 'grafico-piramide',
  mounted () {
    /**
     *  Tratamento do parâmetro de cor. Como a cor é atribuida de acordo com o eixo, e o arquivo esperado
     *  tem 3 series (masculina, feminina e faixa etária, repete-se a cor feminina)
     */
    let listaCor = []

    if (this.cores && Array.isArray(this.cores) && this.cores.length > 1) {
      let am4corMasc = am4core.color(this.cores.shift())
      let am4corFem = am4core.color(this.cores.shift())
      listaCor.push(am4corMasc)
      listaCor.push(am4corFem)
    } else {
      listaCor = [
        // am4core.color(CorUtil.getCorPorNomeSp360('violeta-medio')),
        am4core.color(CorUtil.getCorPorNomeSp360('verde-limao-medio')), // CorUtil.getCorPorNomeSp360('verde-limao-medio')),
        am4core.color(CorUtil.getCorPorNomeSp360('violeta-claro')), // CorUtil.getCorPorNomeSp360('violeta-claro')
      ]
    }

    let rangeEixo = MetodosGlobais.validaRangeEixo(this.rangePorcentagem, [0, 25, 0, 25])
    this.mainContainer = am4core.create(this.$refs.graficoPiramide, am4core.Container)
    this.mainContainer.width = am4core.percent(100)
    this.mainContainer.height = am4core.percent(100)
    this.mainContainer.layout = 'horizontal'

    this.graficoMasculino = this.mainContainer.createChild(am4charts.XYChart)
    this.graficoMasculino.language.locale['_decimalSeparator'] = ','
    this.graficoMasculino.language.locale['_thousandSeparator'] = '.'
    this.graficoMasculino.paddingRight = 0
    this.graficoMasculino.colors.list = listaCor

    var title = this.graficoMasculino.titles.create()
    title.text = 'Masculino'
    title.fontSize = 15
    title.marginBottom = 5

    let eixoEtarioMasc = this.graficoMasculino.yAxes.push(new am4charts.CategoryAxis())
    eixoEtarioMasc.dataFields.category = 'idade'
    eixoEtarioMasc.renderer.grid.template.location = 0
    eixoEtarioMasc.renderer.minGridDistance = 15

    let valoresEixoMasc = this.graficoMasculino.xAxes.push(new am4charts.ValueAxis())
    valoresEixoMasc.renderer.inversed = true
    valoresEixoMasc.min = rangeEixo[0]
    valoresEixoMasc.max = rangeEixo[1]
    valoresEixoMasc.strictMinMax = true

    valoresEixoMasc.numberFormatter = new am4core.NumberFormatter()
    valoresEixoMasc.numberFormatter.numberFormat = "#.#'%'"

    let serieMasc = this.graficoMasculino.series.push(new am4charts.ColumnSeries())
    serieMasc.dataFields.valueX = 'masculino'
    serieMasc.dataFields.valueXShow = 'percent'
    serieMasc.calculatePercent = true
    serieMasc.dataFields.categoryY = 'idade'
    serieMasc.interpolationDuration = 1000
    serieMasc.columns.template.tooltipText = "Homens, Idade {categoryY}: {valueX} ({valueX.percent.formatNumber('#.0')}%)"

    this.graficoFeminino = this.mainContainer.createChild(am4charts.XYChart)
    this.graficoFeminino.language.locale['_decimalSeparator'] = ','
    this.graficoFeminino.language.locale['_thousandSeparator'] = '.'
    this.graficoFeminino.paddingLeft = 0
    this.graficoFeminino.colors.list = listaCor

    var title = this.graficoFeminino.titles.create()
    title.text = 'Feminino'
    title.fontSize = 15
    title.marginBottom = 5

    // Create axes
    let eixoEtarioFem = this.graficoFeminino.yAxes.push(new am4charts.CategoryAxis())
    eixoEtarioFem.renderer.opposite = true
    eixoEtarioFem.dataFields.category = 'idade'
    eixoEtarioFem.renderer.grid.template.location = 0
    eixoEtarioFem.renderer.minGridDistance = 10

    let valoresEixoFem = this.graficoFeminino.xAxes.push(new am4charts.ValueAxis())
    valoresEixoFem.min = rangeEixo[0]
    valoresEixoFem.max = rangeEixo[1]
    valoresEixoFem.strictMinMax = true
    valoresEixoFem.numberFormatter = new am4core.NumberFormatter()
    valoresEixoFem.numberFormatter.numberFormat = "#.#'%'"
    valoresEixoFem.renderer.minLabelPosition = 0.01

    // Create series
    let serieFem = this.graficoFeminino.series.push(new am4charts.ColumnSeries())
    serieFem.dataFields.valueX = 'feminino'
    serieFem.dataFields.valueXShow = 'percent'
    serieFem.calculatePercent = true
    serieFem.fill = this.graficoFeminino.colors.getIndex(4)
    serieFem.stroke = serieFem.fill
    serieFem.columns.template.tooltipText = "Mulheres, Idade {categoryY}: {valueX} ({valueX.percent.formatNumber('#.0')}%)"
    serieFem.dataFields.categoryY = 'idade'
    serieFem.interpolationDuration = 1000
  },
  beforeDestroy () {
    if (this.mainContainer) { this.mainContainer.dispose() }
  },
  data: () => {
    return {
      mainContainer: null,
      graficoMasculino: null,
      graficoFeminino: null,
    }
  },
  props: {
    titulo: {
      type: String,
      default: '',
    },
    cores: {
      type: Array,
      default: () => [],
    },
    dados: {
      type: Array,
      default: () => [],
    },
    rangePorcentagem: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    carregamentoInicial (dados) {
      this.graficoFeminino.data = dados
      this.graficoMasculino.data = dados
    },
    refreshDados (dados) {
      for (var i = 0; i < dados.length; i++) {
        this.graficoMasculino.data[i].masculino = dados[i].masculino
        this.graficoFeminino.data[i].feminino = dados[i].feminino
      }
      this.graficoMasculino.invalidateRawData()
      this.graficoFeminino.invalidateRawData()
    },
  },
  computed: {
    hasTitulo: function () {
      if (this.titulo) { return true }
      return false
    },
  },
}
</script>

<style scoped>
  .tituloGrafico {
    font-size: 24px;
  }
  #graficoContainer{
       width: 100%;
       height: 100%;
  }
  #grafPiramide {
      height: 90%;
  }
  @media (min-width: 561px) and (max-width: 999px) {
    #grafPiramide {
      min-height: 300px;
    }
  }
</style>
